<div [class.disabled]="isDisabled" [class.checked]="isChecked">
  <label class="form-label checkbox-label" [class.d-flex]="displayFlex" data-cy="checkbox">
    <div class="checkmark-container">
      <omgui-checkbox [(ngModel)]="isChecked" (ngModelChange)="handleCheck()" [disabled]="isDisabled"></omgui-checkbox>
    </div>
    <span *ngIf="!!checkboxLabel" class="label-text">{{ checkboxLabel }}</span>
  </label>
</div>
